import { z } from 'zod';

interface User {
  username: string;
  slug: string;
  image: string;
}

interface Document {
  id: number;
  doc_name: string;
  file: string | null;
  upload_date: string;
  uploaded_by: User | null;
  file_size: string;
  file_type: string;
  is_archived: boolean;
  archived_date: string | null;
}

interface ObjectDocsApiResponse {
  documents: Document[];
}

export const createObjectDocSchema = z.object({
  doc_name: z.string().min(1, { message: 'Required field' }),
  file: z.instanceof(File, { message: 'Required field' }),
});

export type ObjectDocFormValues = z.infer<typeof createObjectDocSchema>;

export { ObjectDocsApiResponse, Document, User };
